module.exports = __webpack_public_path__ + "img/img24.810547bd.png";